import React from 'react';
import DynamicLayout from '../components/DynamicLayout';
import AscendantDisplay from '../components/tools/AscendantDisplay';
import '../assets/ascendant-display.sass';

const AscendantPage = () => {
  return (
    <DynamicLayout>
      <AscendantDisplay />
    </DynamicLayout>
  );
};

export default AscendantPage; 
